let metermaps = {

    map: null,
    markers: [],
    instanceLookup: new Map(),
    markersLookup: new Map(),
    SelectedItem: "",
    constants: { fillOpacity: 0.3, activeFillOpacity: 0.1, strokeWidth: 1, activeStrokeWidth: 1, hoverStrokeWidth: 2 },
    colorsLookup: {
        0: "#8ec9e2",
        1: "#ffc960",
        2: "#bbd197",
    },
    getIcon: function (name, active) {

        var size = active ? 20 : 10;

        return {
            url: '/images/maps/map-pins/'.concat(name).concat('.svg'),
            size: new google.maps.Size(size, size),
            scaledSize: new google.maps.Size(size, size),
            anchor: new google.maps.Point(size / 2, size / 2),
            labelOrigin: new google.maps.Point(size / 2, size / 2)
        };
    },
    currentDotNetInstance: {},
    clickCallback: "",
    hoverCallback: "",
    searchCallback: "SearchCallback",
    selectFeature: function (feature) {

        //console.log('Select feature: ', feature, status);
        metermaps.SelectedItem = "";
        if (feature) {
            metermaps.SelectedItem = feature.getProperty('name');

            metermaps.map.data.forEach(function (ft) {
                var status = 0;
                if (ft) {
                    status = ft.getProperty('status');
                }
                //console.log(feature.getProperty('status'));
                metermaps.map.data.overrideStyle(ft, { strokeColor: metermaps.colorsLookup[status], strokeWidth: metermaps.constants.strokeWidth, fillOpacity: metermaps.constants.fillOpacity, zIndex: 1 })
            });


            var element = document.getElementById('ea-123456');

            if (element) {
                element.classList.remove("show");
                element.classList.add("hide");
            }

            var test = new Map();
            feature.forEachProperty(function (value, property) {
                //console.log(property, ':', value);
                test.set(property, value);
            });

            const obj2 = Object.fromEntries(test);
            metermaps.map.data.overrideStyle(feature, { visible: true, strokeColor: "#000000", fillOpacity: metermaps.constants.activeFillOpacity, zIndex: 2 });
            metermaps.currentDotNetInstance.invokeMethodAsync(metermaps.clickCallback, obj2);
        }
        else {
            metermaps.currentDotNetInstance.invokeMethodAsync(metermaps.clickCallback, null);
        }

    },
    filterGeoMap: function (elementId, selected) {

       // console.log('[MAP] filterGeoMap ', selected);
        var map = metermaps.instanceLookup.get(elementId);

        //map.data.revertStyle();
        //map.data.overrideStyle(event.feature, { strokeWeight: 8 });


        map.data.forEach(feature => {


            var status = feature.getProperty('status');

            console.log('[MAP] filterGeoMap ', status);

            if (selected.includes(status)) {
                map.data.overrideStyle(feature, { visible: true })
            }
            else {
                map.data.overrideStyle(feature, { visible: false })
            }

        });
    },
    selectGeoMapFeature: function (elementId) {
       // console.log('[MAP] selectGeoMapFeature ', elementId);
        var map = metermaps.instanceLookup.get(elementId);

        map.data.forEach(feature => {


            var status = feature.getProperty('name');

           // console.log('[MAP] select ', status);

            var geometry = feature.getGeometry();

            geometry.forEachLatLng(function (la, lo) {
                //console.log('lalo', la.toJSON(), la);
            });

            var currPosition = new google.maps.LatLng(59.146, 17.50);

            if (geometry instanceof google.maps.LatLng) {
                //console.log('[MAP] geocheck ll ', geometry);
            } else if (geometry instanceof google.maps.Data.Point) {
                //callback.call(thisArg, geometry.get());
                //console.log('[MAP] geocheck p', geometry.get());
            }
            else {
                geometry.getArray().forEach(function (g) {
                    //processPoints(g, callback, thisArg);
                    var coords = g.getArray();
                    //console.log('[MAP] geometry getarray', g, coords, coords.length);
                    //console.log('coords:', coords);
                    var myarr = [];
                    coords.forEach(function (cc) {
                        //var t1 = Array.from(cc);
                        //console.log('cc:', cc.lat())
                        myarr.push({ lat: cc.lat(), lng: cc.lng() });
                    });

                    // console.log('myarr:', myarr);

                    const coordPolygon = new google.maps.Polygon({
                        paths: myarr
                    });

                    const inside = google.maps.geometry.poly.containsLocation(
                        currPosition,
                        coordPolygon
                    );

                    // console.log('is within', inside, currPosition);

                    if (inside) {
                        map.data.overrideStyle(feature, { visible: true, strokeWeight: 4 });
                    }
                    else {
                        map.data.overrideStyle(feature, { visible: true, strokeWeight: 2 });
                    }

                });
            }
        });

    },
    selectGeoMapFeatureByCoords: function (elementId, place) {

      //  console.log('[MAP] selectGeoMapFeature ', elementId, place);

        if (!place.geometry || !place.geometry.location) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            //    window.alert("No details available for input: '" + place.name + "'");
            var result = { PlaceName: place.name, Unknown: true };
            console.log('no place found2: ', result);
            metermaps.currentDotNetInstance.invokeMethodAsync(metermaps.searchCallback, { PlaceName: place.name, Unknown: true });
            return;
        }


        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();

        var map = metermaps.instanceLookup.get(elementId);

        // add marker
        var latlng = new google.maps.LatLng(lat, lng);

        var marker = metermaps.markersLookup.get(elementId);

        if (marker) {
          //  console.log('[MAP] marker found', marker);
            marker.setMap(null);
        }


        var newMarker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: maps.getIcon(maps.icons.default, false),

        });

        newMarker.addListener('mouseover', function (e) {
            newMarker.setOpacity(0.8);
            newMarker.setIcon(maps.getIcon(maps.icons.default, true));
        });

        newMarker.addListener('mouseout', function () {
            newMarker.setOpacity(1.0);
            newMarker.setIcon(maps.getIcon(maps.icons.default, false));
        });

      //  console.log('[MAP] setting marker', newMarker);
        newMarker.setMap(map);

        //maps.markers.push(newMarker);
        metermaps.markersLookup.set(elementId, newMarker);
        map.setCenter(latlng);

        var anyselected = false;

        map.data.forEach(feature => {


            var status = feature.getProperty('name');

          //  console.log('[MAP] select ', status);

            var geometry = feature.getGeometry();

            var currPosition = new google.maps.LatLng(lat, lng);


            geometry.getArray().forEach(function (g) {
                var coords = g.getArray();

                var myarr = [];
                coords.forEach(function (cc) {
                    myarr.push({ lat: cc.lat(), lng: cc.lng() });
                });


                //console.log('paths:', paths1);
                //console.log('myarr:', myarr);

                const coordPolygon = new google.maps.Polygon({
                    paths: myarr
                });

                const inside = google.maps.geometry.poly.containsLocation(
                    currPosition,
                    coordPolygon
                );

                //console.log('yo is within', inside, currPosition);

                if (inside) {
                    //map.data.overrideStyle(feature, { visible: true, strokeWeight: 4 });
                    // console.log('select', feature);
                    metermaps.selectFeature(feature);
                    anyselected = true;
                }
                else {
                    //map.data.overrideStyle(feature, { visible: true, strokeWeight: 1 });
                }
            });
        });

        if (!anyselected) {
            // none selected
            metermaps.selectFeature(null);
            metermaps.currentDotNetInstance.invokeMethodAsync(metermaps.searchCallback, { placeName: place.name, unknown: false });
        }
        else {
            metermaps.currentDotNetInstance.invokeMethodAsync(metermaps.searchCallback, { clear: true });
        }

    },
    initGeoMap: function (dotNetInstance, elementId, mapConfig, clickCallback) {

        const host = window.location.protocol.concat('//', window.location.host);
     //   console.log('[MAP] initGeoMap', mapConfig, host);
        metermaps.currentDotNetInstance = dotNetInstance;
        metermaps.clickCallback = clickCallback;
        //maps.initDotNetInstance(dotNetInstance, clickCallback, clickCallback);

        var searchField = document.getElementById('pac-input');
        if (searchField) {
            searchField.value = '';
        }

        var element = document.getElementById(elementId);

        if (!element) {
            return;
        }


        var config = {
            center: { lat: mapConfig.lat, lng: mapConfig.lng },
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            scaleControl: false,
            overviewMapControl: false,
            streetViewControl: false,
            panControl: false,
            fullscreenControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            overviewMapControlOptions: { opened: true },
            styles: maps.config.styles
        }


        var map = new google.maps.Map(element, config);
        metermaps.map = map;
        map.data.loadGeoJson(
            host.concat(mapConfig.geoJson)
        );

        const iconsLookup = {
            0: maps.icons.planned,
            1: maps.icons.ongoing,
            2: maps.icons.completed
        };

        map.data.setStyle(function (feature) {
            var status = feature.getProperty('status');
            return {
                fillColor: metermaps.colorsLookup[status],
                strokeWeight: metermaps.constants.strokeWidth,
                strokeColor: metermaps.colorsLookup[status],
                fillOpacity: metermaps.constants.fillOpacity,
                zIndex: 1
            };
        });

        map.data.addListener('addfeature', function (e) {
            var status = e.feature.getProperty('status');
            var phase = e.feature.getProperty('phase');
            var displayName = e.feature.getProperty('displayName');
            var bounds = new google.maps.LatLngBounds();
            e.feature.getGeometry().getArray().forEach(function (path) {
                path.getArray().forEach(function (latLng) {
                    bounds.extend(latLng);
                })
            });

            var polypoint = bounds.getCenter();
            //console.log(polypoint);

            var marker = new google.maps.Marker({
                map: map,
                position: { lat: polypoint.lat(), lng: polypoint.lng() },
                icon: metermaps.getIcon(iconsLookup[status], false),
                label: { text: displayName, className: 'marker-label-' + status },

            });

            marker.addListener('click', function (ev) {
                //console.log('Map marker clicked: ', e.feature);
                metermaps.selectFeature(e.feature);
            });

            new google.maps.Marker(marker);

        });

        map.data.addListener('mouseover', function (event) {
            map.addListener('click', function (event) {
                //console.log('Map clicked: ', event);
                metermaps.selectFeature(null);
            });

            map.data.addListener('click', function (event) {
                //console.log('Map data clicked: ', event.feature);
                metermaps.selectFeature(event.feature);
            });

            if (!metermaps.SelectedItem.startsWith(event.feature.getProperty('name'))) {
                metermaps.map.data.overrideStyle(event.feature, { strokeOpacity: 0.7, fillOpacity: metermaps.constants.activeFillOpacity, strokeWeight: metermaps.constants.strokeWidth });

                map.data.addListener('mouseout', function (event) {
                    if (!metermaps.SelectedItem.startsWith(event.feature.getProperty('name'))) {

                        metermaps.map.data.overrideStyle(event.feature, { strokeOpacity: 1.0, fillOpacity: metermaps.constants.fillOpacity, strokeWeight: metermaps.constants.strokeWidth });
                    }
                });
            }
        });

        metermaps.instanceLookup.set(elementId, map);

        let center = { lat: 59.12, lng: 17.54 };
        // Create a bounding box with sides ~10km away from the center point
        const defaultBounds = {
            north: center.lat + 0.3,
            south: center.lat - 0.3,
            east: center.lng + 0.3,
            west: center.lng - 0.3,
        };


        const input = document.getElementById("pac-input");
        const options = {
            bounds: defaultBounds,
            componentRestrictions: { country: "se" },
            fields: ["address_components", "geometry", "icon", "name"],
            strictBounds: true,
            types: [],
        };

        map.setZoom(10.5);

        if (window.innerWidth < 1200) {
            center = { lat: 59.09, lng: 17.54 };

        }
        if (window.innerWidth < 740) {
            map.setZoom(9.5);

        }
        map.setCenter(center);

        var paccontainer = document.querySelector(".pac-container");
        if (paccontainer) {
            paccontainer.remove();
        }
        const autocomplete = new google.maps.places.Autocomplete(input, options);
        var geocoder = new google.maps.Geocoder();

        document.addEventListener('DOMNodeInserted', function (event) {
            var target = event.target;
            if (target.classList && target.classList.contains('pac-item')) {

                var last = target.lastChild;
                last.innerText = last.innerText.replace(', Sverige', '');
            }

        }, false);
        autocomplete.addListener("place_changed", () => {
            //console.log('place changed');
            var place = autocomplete.getPlace();

            input.value = input.value.replace(', Sverige', '');

            if (!place.geometry || !place.geometry.location) {

                var item = document.querySelector(".pac-item");
                if (item) {
                    var adress = item.innerText;

                    if (adress) {
                        try {
                            geocoder.geocode({ 'address': adress },
                                function (results, status) {
                                    if (status == google.maps.GeocoderStatus.OK) {
                                        var s = results;

                                        var newplace = results[0];
                                        metermaps.selectGeoMapFeatureByCoords(elementId, newplace);
                                    }
                                    else {
                                        metermaps.selectGeoMapFeatureByCoords(elementId, place)
                                    }
                                });

                        }
                        catch {
                            metermaps.selectGeoMapFeatureByCoords(elementId, place)
                        }
                    }
                }
                else {
                    metermaps.selectGeoMapFeatureByCoords(elementId, place)
                }
            }
            else {
                metermaps.selectGeoMapFeatureByCoords(elementId, place)
            }

        });

        console.log('geomap init complete');
    }
};

export { metermaps };
